  <!-- CP TEMPLATE -->
  <div *ngIf="type === 'office'">
  <div
      class="container-wopi-fluid"
  >
      <div class="preview-wrap">
          <app-error [errcode]="errcode"></app-error>

          <div *ngIf="spinner && !errcode" class="preview-loading-wrap">
            <sync-spinner></sync-spinner>
          </div>

          <div
              class="preview-iframe-wopi"
              *ngIf="!errcode && initialized"
          >
              <iframe
                  class="preview-iframe-wopi"
                  frameborder="0"
                  name="office_frame"
                  id="office_frame"
                  title="Office Online Frame"
                  allowfullscreen="true"
                  sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
              >
              </iframe>
          </div>
      </div>
  </div>
</div>
  <!-- /container -->
  <!-- /CP TEMPLATE -->

  <div *ngIf="type === 'officefsv' || type === 'officefse'">
    <div class="preview-wrap-wopi-fullscreen">
        <app-error [errcode]="errcode"></app-error>
  
        <div *ngIf="spinner && !errcode" class="preview-loading-wrap">
            <sync-spinner></sync-spinner>
        </div>
  
        <div
            class="preview-iframe-wopi-fullscreen-wrap"
            *ngIf="!errcode && initialized"
        >
            <iframe
                class="preview-iframe-wopi-fullscreen"
                frameborder="0"
                name="office_frame"
                id="office_frame"
                title="Office Online Frame"
                allowfullscreen="true"
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
            >
            </iframe>
        </div>
    </div>
    <!-- /container -->
  </div>